import store from "@/state/store";
import axios from "axios";

export default [
  {
    path: "*",
    meta: { authRequired: false, nav: true, name: "dashboard" },
    component: () => {
      switch (store.getters["getUserType"]) {
        case "company":
          window.location.href = "/dashboard";
          return;
        case "hacker":
          window.location.href = "/dashboard";
          return;
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },

  {
    path: "/overview",
    meta: { authRequired: false, nav: true, name: "dashboard" },
    component: () => {
      switch (store.getters["getUserType"]) {
        case "company":
          return import("../view/company/dashboard/overview");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },

  {
    path: "/dashboard",
    meta: { authRequired: false, nav: true, name: "dashboard" },
    component: () => {
      switch (store.getters["getUserType"]) {
        case "company":
          return import("../view/company/dashboard/home");
        case "hacker":
          return import("../view/hacker/dashboard/home");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },

  {
    path: "/report/details",
    meta: { authRequired: false, nav: true, name: "report" },
    component: () => {
      switch (store.getters["getUserType"]) {
        case "company":
          return import("../components/report/details");
        case "hacker":
          return import("../components/report/details");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },

  {
    path: "/dashboard/invitations",
    meta: { authRequired: false, nav: true, name: "dashboard" },
    component: () => {
      switch (store.getters["getUserType"]) {
        case "company":
          return import("../view/company/dashboard/invitations");
        case "hacker":
          return import("../view/hacker/dashboard/invitations");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },

  {
    path: "/program/invitations",
    meta: { authRequired: false, nav: true, name: "program" },
    component: () => {
      switch (store.getters["getUserType"]) {
        case "company":
          return import("../view/company/dashboard/invitations");
        case "hacker":
          return import("../view/hacker/dashboard/invitations");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },

  {
    path: "/dashboard/invoice",
    meta: { authRequired: false, nav: true, name: "dashboard" },
    component: () => {
      switch (store.getters["getUserType"]) {
        case "company":
          return import("../view/company/dashboard/invoice");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },

  {
    path: "/dashboard/payment",
    meta: { authRequired: false, nav: true, name: "dashboard" },
    component: () => {
      switch (store.getters["getUserType"]) {
        case "hacker":
          return import("../view/hacker/dashboard/payment");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },

  {
    path: "/program/nda",
    meta: { authRequired: false, nav: true, name: "program" },
    component: () => {
      switch (store.getters["getUserType"]) {
        case "company":
          return import("../view/company/program/nda");
        case "hacker":
          return import("../view/hacker/program/nda");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },
  {
    path: "/program/vpn",
    meta: { authRequired: false, nav: true, name: "program" },
    component: () => {
      switch (store.getters["getUserType"]) {
        case "company":
          return import("../view/company/program/vpn");
        // case "hacker":
        //   return import("../view/hacker/program/nda");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },
  {
    path: "/program/campaign",
    meta: { authRequired: false, nav: true, name: "program" },
    component: () => {
      switch (store.getters["getUserType"]) {
        case "company":
          return import("../view/company/program/tableCampaignHistory");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },
  {
    path: "/program/set-nda",
    meta: { authRequired: false, nav: true, name: "program" },
    component: () => {
      switch (store.getters["getUserType"]) {
        case "company":
          return import("../view/company/dashboard/set-nda");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },

  {
    path: "/program",
    meta: { authRequired: false, nav: true, name: "program" },
    component: () => {
      switch (store.getters["getUserType"]) {
        case "company":
          return import("../view/company/program/home");
        case "hacker":
          return import("../view/hacker/program/home");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },

  {
    path: "/program/published",
    meta: { authRequired: false, nav: true, name: "program" },
    component: () => {
      switch (store.getters["getUserType"]) {
        case "company":
          return import("../view/company/program/published");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },

  {
    path: "/program/inactive",
    meta: { authRequired: false, nav: true, name: "program" },
    component: () => {
      switch (store.getters["getUserType"]) {
        case "company":
          return import("../view/company/program/inactive");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },

  {
    path: "/program/create",
    meta: { authRequired: false, nav: true, name: "program" },
    component: () => {
      switch (store.getters["getUserType"]) {
        case "company":
          return import("../view/company/program/create");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },

  {
    path: "/program/detail",
    meta: { authRequired: false, nav: true, name: "program" },
    component: () => {
      switch (store.getters["getUserType"]) {
        case "company":
          return import("../view/company/program/detail");
        case "hacker":
          return import("../view/hacker/program/details");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },

  {
    path: "/program/edit",
    meta: { authRequired: false, nav: true, name: "program" },
    name: "editProgram",
    component: () => {
      switch (store.getters["getUserType"]) {
        case "company":
          return import("../view/company/program/edit");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },

  {
    path: "/program/submit",
    meta: { authRequired: false, nav: true, name: "program" },
    name: "programSubmit",
    component: () => {
      switch (store.getters["getUserType"]) {
        case "hacker":
          return import("../view/hacker/program/submitReport");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },

  {
    path: "/wiki",
    name: "wiki",
    meta: { authRequired: false, nav: true, name: "wiki" },
    component: () => {
      switch (store.getters["getUserType"]) {
        case "company":
          return import("../view/company/wiki/home");
        case "hacker":
          return import("../view/hacker/wiki/home");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },

  {
    path: "/wiki/suport",
    name: "wiki suport",
    meta: { authRequired: false, nav: true, name: "wiki" },
    component: () => {
      switch (store.getters["getUserType"]) {
        case "company":
          return import("../components/suport");
        case "hacker":
          return import("../components/suport");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },

  {
    path: "/ranking",
    meta: { authRequired: false, nav: true, name: "ranking" },
    component: () => import("../components/rankingGeral"),
  },

  {
    path: "/rankingMonthly",
    meta: { authRequired: false, nav: true, name: "ranking" },
    component: () => import("../components/rankingMensal"),
  },

  {
    path: "/report",
    meta: { authRequired: false, nav: true, name: "report" },
    component: () => {
      switch (store.getters["getUserType"]) {
        case "company":
          return import("../view/company/report/home");
        case "hacker":
          return import("../view/hacker/report/home");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },
  {
    path: "/jobs",
    meta: { authRequired: false, nav: false, name: "jobs" },
    component: () => {
      switch (store.getters["getUserType"]) {
        case "company":
          return import("../components/jobs/home");
        case "hacker":
          return import("../components/jobs/home");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },

  {
    path: "/report/pending",
    meta: { authRequired: false, nav: true, name: "report" },
    component: () => {
      switch (store.getters["getUserType"]) {
        case "company":
          return import("../view/company/report/pending");
        case "hacker":
          return import("../view/hacker/report/pending");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },

  {
    path: "/report/retest",
    meta: { authRequired: false, nav: true, name: "report" },
    component: () => {
      switch (store.getters["getUserType"]) {
        case "company":
          return import("../view/company/report/retest");
        case "hacker":
          return import("../view/hacker/report/retest");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },
  {
    path: "/report/triaged",
    meta: { authRequired: false, nav: true, name: "report" },
    component: () => {
      switch (store.getters["getUserType"]) {
        case "company":
          return import("../view/company/report/triaged");
        case "hacker":
          return import("../view/hacker/report/triaged");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },

  {
    path: "/ranking/timeline",
    meta: { authRequired: false, nav: true, name: "ranking" },
    component: () => {
      switch (store.getters["getUserType"]) {
        case "hacker":
          return import("../view/hacker/ranking/timelinePoints");
        default:
          store.dispatch("resetUser");
          axios.post(store.getters["getApiUrl"] + `auth/logout`);
          window.location.href = "/login";
          return;
      }
    },
  },

  // {
  //   path: "/profile",
  //   meta: { authRequired: false, nav: false, name: "profile" },
  //   component: () => {
  //     switch (store.getters["getUserType"]) {
  //       case "hacker":
  //         return import("../view/hacker/profile/home");
  //       default:
  //         store.dispatch("resetUser");
  //         axios.post(store.getters["getApiUrl"] + `auth/logout`);
  //         window.location.href = "/login";
  //         return;
  //     }
  //   },
  // },

  {
    path: "/account",
    name: "account",
    meta: { authRequired: false },
    component: () => import("../components/account/home"),
  },

  {
    path: "/login",
    name: "login",
    component: () => import("../view/account/login"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "dashboard" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },

  {
    path: "/register",
    name: "Register",
    component: () => import("../view/account/register"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "home" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },

  {
    path: "/register_ame",
    name: "RegisterAME",
    component: () => import("../view/account/registerAme"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "home" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },

  {
    path: "/company",
    name: "RegisterCompany",
    component: () => import("../view/account/registerCompany"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "home" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/company/member",
    name: "CompanyMember",
    component: () => import("../view/account/company-member"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "home" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },

  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../view/account/forgot-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "home" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },

  {
    path: "/reset-password",
    name: "Reset password",
    component: () => import("../view/account/reset-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "home" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },

  {
    path: "/validation",
    name: "Email validation",
    component: () => import("../view/account/validation"),
  },

  {
    path: "/logout",
    name: "logout",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/login"),
        );
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute ? { name: "default" } : { ...routeFrom },
        );
      },
    },
  },

  {
    path: "/program-list",
    name: "Program list",
    component: () => import("../view/vdp/index"),
    meta: {
      // beforeResolve(routeTo, routeFrom, next) {
      // },
    },
  },
  {
    path: "/:slug",
    name: "Program Detail",
    component: () => import("../view/vdp/detail"),
    meta: {
      slug: true,
    },
  },
  {
    path: "/hall-of-fame/:slug",
    meta: { authRequired: true, name: "hallOfFame", slug: true },
    component: () => import("../components/hallOfFame"),
  },
];
